const locale = {
  MODAL_VERIFICATION_TITLE: 'Ingresa el código de verificación',
  MODAL_VERIFICATION_DESCRIPTION: `Hemos enviado un código de 6 dígitos a tu correo. Ingrésalo para verificar tu cuenta.`,
  MODAL_VERIFICATION_BUTTON: 'Verificar',
  MODAL_VERIFICATION_NOT_RECEIVED_CODE: '¿No recibiste el código?',
  MODAL_VERIFICATION_TEXT_TIMER: 'Puedes reenviarlo en',
  MODAL_VERIFICATION_RESEND_CODE: 'Reenviar el código',
  MODAL_VERIFICATION_FAILED_ATTEMPTS: 'Demasiados intentos fallidos',
  MODAL_VERIFICATION_TRY_AGAIN: 'Intenta de nuevo en',
};

export default locale;
